import { render, staticRenderFns } from "./profile-detail.vue?vue&type=template&id=230dcda4"
import script from "./profile-detail.vue?vue&type=script&lang=js"
export * from "./profile-detail.vue?vue&type=script&lang=js"
import style0 from "./profile-detail.vue?vue&type=style&index=0&id=230dcda4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports